<template>
  <div>
    <appResolutionsCatalog :is-new="false" />
  </div>
</template>

<script>
import appResolutionsCatalog from "@/components/catalogs/resolutions/ResolutionsCatalog";

export default {
  components: {
    appResolutionsCatalog,
  },
};
</script>
